import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Components
import Header from './components/molecules/Header';
import Footer from './components/molecules/Footer';

// Pages
import Waitlist from './pages/Waitlist';
import Homepage from './pages/Homepage';
import Login from './pages/Login';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Signup from './pages/Signup';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Helmet>
                <title>IntenceAI • AI-Driven Social Media Automation</title>
                <meta
                  name="description"
                  content="Automate your Twitter postings with IntenceAI, an AI-driven tool that learns from engagement to optimize your social media strategy and save you time."
                />
              </Helmet>
              <Waitlist />
            </>
          }
        />

        <Route
          path="/home"
          element={
            <>
              <Helmet>
                <title>IntenceAI • AI-Driven Social Media Automation</title>
                <meta
                  name="description"
                  content="Automate your Twitter postings with IntenceAI, an AI-driven tool that learns from engagement to optimize your social media strategy and save you time."
                />
              </Helmet>
              <Header />
              <Homepage />
              <Footer />
            </>
          }
        />

        <Route
          path="/login"
          element={
            <>
              <Helmet>
                <title>IntenceAI • Login</title>
                <meta
                  name="description"
                  content="Log in to IntenceAI to manage your automated social media posts, track engagement, and refine your AI-driven content strategy."
                />
              </Helmet>
              <Header />
              <Login />
              <Footer />
            </>
          }
        />

        <Route
          path="/onboarding"
          element={
            <>
              <Helmet>
                <title>IntenceAI • Onboarding</title>
                <meta
                  name="description"
                  content="Set up your IntenceAI account in a few simple steps. Let our AI learn your brand voice and start automating your daily Twitter posts."
                />
              </Helmet>
              <Header />
              <Onboarding />
              <Footer />
            </>
          }
        />

        <Route
          path="/dashboard"
          element={
            <>
              <Helmet>
                <title>IntenceAI • Dashboard</title>
                <meta
                  name="description"
                  content="Your all-in-one hub for scheduling posts, tracking social media performance, and fine-tuning your AI-generated content."
                />
              </Helmet>
              <Header />
              <Dashboard />
              <Footer />
            </>
          }
        />

        <Route
          path="/signup"
          element={
            <>
              <Helmet>
                <title>IntenceAI • Sign Up</title>
                <meta
                  name="description"
                  content="Join IntenceAI to automate your social media strategy. Seamlessly schedule posts and let our AI learn and grow your engagement."
                />
              </Helmet>
              <Header />
              <Signup />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
